import { GetLocationFromIPResponse } from '@eventbrite/geo-service-pysoa-model';
import { getLocationFromIP as getLocationFromIPEcs } from '@/api/geo/getLocationFromIP';

/**
 * Get the location from coordinates via geo-service-http (ECS/Fargate).
 *
 * @param ip_address the ip address of the user
 * @param auth_token the eb-soa token for the user
 */
export const getLocationFromIP = async (
    ip_address: string,
    auth_token: string,
): Promise<GetLocationFromIPResponse | null> => {
    try {
        if (!ip_address || !auth_token) {
            return null;
        }

        return getLocationFromIPEcs(ip_address);
    } catch (e) {
        console.error('Failed to fetch location from IP');
        console.error(e);
        return null;
    }
};
